// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"3c7e3f96","453":"b12d8134","455":"41a8f0b3","977":"62bab440"}[chunkId] + ".chunk.js";
};